import { cloneDeep } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { getHammerTime, getLocaleDateString, getLocaleTimeString, proxy } from '@/utils'

import render from './render'

export const scheduleTypes = {
  now: 'now',
  latter: 'latter'
}

const defaultDate = {
  until: 0,
  delay: {
    date: undefined,
    time: getHammerTime(new Date())
  }
}

export default {
  name: 'Schedule',

  mixins: [ proxy() ],

  data() {
    return {
      show: false,
      scheduleType: scheduleTypes.now,
      timezoneOffset: this.$store.getters['global/date'].getTimezoneOffset(),
      changeableDates: cloneDeep(defaultDate)
    }
  },

  computed: {
    schedule() {
      let delay = 0
      if (this.changeableDates.delay.date) {
        const hours = ('' + Math.floor(Math.abs(this.timezoneOffset / 60))).padStart(2, '0')
        const minutes = ('' + Math.abs(this.timezoneOffset % 60)).padStart(2, '0')
        let timezoneSign = '+'
        if (this.timezoneOffset > 0) {
          timezoneSign = '-'
        }

        const timezone = timezoneSign + hours + ':' + minutes
        delay = new Date(this.changeableDates.delay.date + 'T' + this.changeableDates.delay.time + ':00' + timezone)
      }

      let until
      if (this.changeableDates.until > 0) {
        until = new Date(delay)
        until.setHours(until.getHours() + this.changeableDates.until)
      }

      return {
        delay,
        until
      }
    },

    formatDelay() {
      if (this.schedule?.delay) {
        return [ getLocaleDateString(this.schedule.delay), getLocaleTimeString(this.schedule.delay) ].join(' ')
      }

      return this.getTranslate(`${Services.sendings}.schedule.no.date`)
    },

    untilItems() {
      return [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ].map(item => {
        return {
          title: this.getTranslate(`${Services.sendings}.schedule.until.${item}`),
          value: item
        }
      })
    }
  },

  watch: {
    schedule: {
      handler(value) {
        this.proxy = value
      },
      deep: true
    },

    scheduleType(value) {
      if (value === scheduleTypes.now) {
        this.changeableDates.delay.date = undefined
        this.changeableDates.until = 0
      }
    }
  },

  methods: {
    setDefaultSchedule() {
      this.changeableDates = cloneDeep(defaultDate)
      if (this.scheduleType === scheduleTypes.now) {
        this.changeableDates.delay.date = undefined
      }
    }
  },

  render
}
